/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFileSmile = createReactComponent("file-smile", "IconFileSmile", [
  ["path", { d: "M14 3v4a1 1 0 0 0 1 1h4", key: "svg-0" }],
  [
    "path",
    {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2zm-7 -7h.01m3.99 0h.01",
      key: "svg-1"
    }
  ],
  ["path", { d: "M10 17a3.5 3.5 0 0 0 4 0", key: "svg-2" }]
]);

export { IconFileSmile as default };
//# sourceMappingURL=IconFileSmile.js.map
